import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAccountingMode } from '../contexts/AccountingModeContext';

const DashboardLayout = () => {
  const { isTotalMode } = useAccountingMode();

  return (
    <div className="flex" style={{ height: '100dvh', minHeight: '-webkit-fill-available' }}>
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <Header />
        <main 
          className={`flex-1 overflow-y-auto overscroll-contain p-4 sm:p-6 transition-colors ${
            isTotalMode ? 'bg-[#E8E8E8]' : 'bg-[#F0F0F0]'
          }`}
          style={{ WebkitOverflowScrolling: 'touch' }}
        >
          {isTotalMode && (
            <div className="opacity-5 pointer-events-none fixed inset-0 z-0 flex items-center justify-center text-9xl font-bold text-yellow-500 rotate-45 select-none" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
              INTERNE
            </div>
          )}
          <div className="relative z-10 pb-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
